
class BonusGameData extends SlotGame.src.store.BonusGameData {


    public isStarted(): boolean {
        return this.win >= 0 && this.multiplier().hasOwnProperty('multiplier');
    }

    public isFinished(): boolean {
        return false
    }

    multiplier(): number {
        return <any>this.extra;
    }
}

export {BonusGameData};

SlotGame.src.store.BonusGameData = BonusGameData;




